export function ytKontrolaPoModulu11(broj:string, dodatni_uslov:string) : string{
    let kb:number = 0;
    let mnozilac:number = 2;
    
    for(let i:number = broj.length-1; i>=0; i--){
        kb+= parseInt(broj.charAt(i),10)*mnozilac;
        mnozilac = mnozilac == 7 ? 2: mnozilac + 1;
    }

    kb = 11 - (kb % 11);

    if (dodatni_uslov == "jmbg"){
        return kb > 9 ? "0" : kb.toString();
    }
    else if (dodatni_uslov == "mb"){
        return kb == 11 ? "0" : kb == 10 ? "X" : kb.toString();
    }
    else
        return kb.toString();


}